import humanize from '../../shared/utils/humanize';
import wait from 'waait';
import { Fetch, RenderedParams } from '../../shared/types';
import type { Give, ActionType, Sample } from '../types';

type GiveWithOptionalLabel = Omit<Give, 'label'> & Partial<Pick<Give, 'label'>>;

// Generate labels for gives that don't have one by humanizing the key
const buildGives = (gives: GiveWithOptionalLabel[]): Give[] =>
  gives.map((give) => ({
    ...give,
    label:
      give.label ||
      humanize(give.key.replace(/__/g, ': ').replace(/\[]/g, ' (List): ')),
  }));

export type RequestData = {
  selected_api: string;
  type_of: ActionType;
  action: string;
  authentication_id?: number;
  params?: RenderedParams;
  read_result?: Sample;
};

export type ResponseData = {
  gives: GiveWithOptionalLabel[];
};

function fetchGives(
  fetch: Fetch,
  body: RequestData,
  delay = 200,
  tries = 2
): Promise<Give[]> {
  async function onError(err: unknown) {
    tries -= 1;
    if (!tries) {
      throw err;
    }
    await wait(delay);
    return fetchGives(fetch, body, delay, tries);
  }
  return fetch<ResponseData>('/api/v4/implementations/gives/', { body })
    .then(({ gives }) => buildGives(gives))
    .catch(onError);
}

export const getGives = (fetch: Fetch, body: RequestData) => {
  return fetchGives(fetch, body);
};

export default getGives;
